import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { Input } from '../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { FormFooter } from '../../../elements/form-footer';
import { FieldError } from "../../../elements/field-error/field-error";
import { Select } from '../../../elements/select';
import { DatePicker } from '../../../elements/date-picker';

// construccion del objecto yup de validacion del cuestionario
let obligado = {
    name: Yup.string().required('obligatorio'),
    brand: Yup.string().required('obligatorio'),
    //start_production_date: Yup.string().required('obligatorio'),
    //end_production_date: Yup.string().required('obligatorio')
};
const validacion = Yup.object().shape(obligado);

const initialValues = {
    name: '',
    brand: '',
};

export const ModelosForm = ({
    item,
    close,
    doDelete
}: {
    item?: any;
    close: () => void;
    doDelete?: (item: any) => void;
}) => {

    const { t } = useTranslation();
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);
    const [marcas, setMarcas] = useState<any | null>([]);


    useEffect(() => {
        api('/fleet/car-brands/?limit=9999', 'GET');
    }, []);



    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);

    const beforeSubmit = (values: any | null) => {
        let after = { ...values };

        console.log('after', after)

        return after;
    };

    const onSubmit = async (values: any | null) => {
        //
        const enviaremos = beforeSubmit(values);

        if (enviaremos.id) {

            // update
            api(`/fleet/car-models/${enviaremos.id}/`, 'PATCH', enviaremos);
        } else {
            // create
            api('/fleet/car-models/', 'POST', enviaremos);
        }
    };

    useEffect(() => {

        if (state.data) {
            if (state.path.includes('brands')) {
                setMarcas(state.data.results);

            }
            if (state.path.includes('models')) {
                close();
            }
        }

        if (state.error) {
            if (state.error.non_field_errors && state.error.non_field_errors[0] === "Los campos brand, name deben formar un conjunto único.") {
                toast.error(`${t('common.label.error.modelo')}`);
            }else{
                toast.error('Server Error');
            }
        }
    }, [state]);

    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={data || initialValues}
                validationSchema={validacion}
                validateOnBlur={true}
                onSubmit={onSubmit}
            >
                {({
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    handleSubmit,
                    isSubmitting
                }) => (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <div className="flex">
                            <div className="w-full">
                                <div className="my-[11px] w-full">
                                    {/* --------------------MARCA-------------------  */}

                                    <Select
                                        name="brand"
                                        label={t('common.label.marca')}
                                        placeholder="Select value"
                                        items={marcas}
                                        value={values.brand}
                                        onChange={(value) => {
                                            setFieldValue('brand', value.brand);
                                        }}

                                        
                                    />
                                    <FieldError touched={touched} errors={errors} field={"brand"} />
                                    {/* --------------------MARCA------------------- */}
                                    {/* --------------------NAME------------------- */}
                                    <Input
                                        name="name"
                                        label={t('common.label.modelo')}
                                        type="text"
                                        placeholder={t('common.label.modelo')}
                                        value={values.name}
                                        onChange={(value) =>
                                            setFieldValue('name', value.name)
                                        }
                                    />
                                    <FieldError touched={touched} errors={errors} field={"name"} />
                                    {/* --------------------NAME------------------- */}

                                </div>
                            </div>

                            <FormFooter
                                item={item}
                                doDelete={doDelete}
                                doSubmit={handleSubmit}
                                close={close}
                            />
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
};